import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { TestModeService } from '../services/test-mode.service';

export const testModeGuard: CanActivateFn = () => {
  const testMode = inject(TestModeService);
  const router = inject(Router);
  return testMode.ensureLoaded().pipe(
    map(enabled => enabled || router.createUrlTree(['/system-admin/dashboard'])),
  );
};
